import React from 'react';
import { Stack, Typography } from '@mui/material';
import Moment from 'moment';
import { money } from './payrollMath';

const has = (v) => v !== '' && v !== null && v !== undefined;

// Read-only details of one payroll payment (empPayment row).
export default function HistoryView({ history }) {
    const h = history || {};
    const name = [h.mEmployeeFirstName, h.mEmployeeLastName].filter(Boolean).join(' ') || '-';
    const row = (label, value) => (
        <Typography variant="body2" gutterBottom>
            {label}: <b>{value}</b>
        </Typography>
    );
    return (
        <Stack direction="column" alignItems="start" spacing={0.5}>
            {row('Paid To', name)}
            {row('Pay Period', `${Moment(h.fromDate).format('MM/DD/YYYY')} - ${Moment(h.toDate).format('MM/DD/YYYY')}`)}
            {has(h.createdDate) && row('Paid On', Moment(h.createdDate).format('MM/DD/YYYY'))}
            {has(h.payoutAmount) && row('Total Payout', money(h.payoutAmount))}
            {row('Paid Cash Amount', money(has(h.paidCashAmount) ? h.paidCashAmount : 0))}
            {row('Paid Check Amount', money(has(h.paidCheckAmount) ? h.paidCheckAmount : 0))}
            {has(h.checkNum) && row('Check Number', h.checkNum)}
            {has(h.salaryOffset) && Number(h.salaryOffset) > 0 && row('Salary Offset', money(h.salaryOffset))}
            {row('Notes', has(h.notes) ? h.notes : '-')}
        </Stack>
    );
}
